<template>
    <div
        class="font-semibold text-sm text-red-500 p-4 rounded-lg2 border border-red-500 bg-red-50 flex items-center gap-2"
    >
        <Icon
            name="close"
            class="w-5 h-5 text-red-500"
        />
        <span class="text-sm">
            {{ errorMessage }}
        </span>
    </div>
</template>

<script lang="ts" setup>
    import Icon from '@/Shared/Component/Icon.vue'

    const props = defineProps({
        errorMessage: {
            type: String,
            default: null,
        },
    })
</script>
